import React, { useState, useEffect } from 'react'
import './nav.css'
import {BiHome, BiNetworkChart, BiBriefcaseAlt2, BiComment} from 'react-icons/bi'
import {AiOutlineUser, AiOutlineProject, AiOutlinePhone} from 'react-icons/ai'

const sections = ['home', 'about', 'work', 'experience', 'services', 'testimonials', 'contact']

const Nav = () => {
  const [activeNav, setActiveNav] = useState('#home')

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const hash = '#' + entry.target.id
            setActiveNav(hash)
            window.history.replaceState(null, '', hash)
          }
        })
      },
      { threshold: 0.3 }
    )

    sections.forEach((id) => {
      const el = document.getElementById(id)
      if (el) observer.observe(el)
    })

    return () => observer.disconnect()
  }, [])

  return (
    <nav>
      <a href='#home' className={activeNav === '#home' ? 'active' : ''} title='Home'><BiHome/></a>
      <a href='#about' className={activeNav === '#about' ? 'active' : ''} title='About'><AiOutlineUser/></a>
      <a href='#work' className={activeNav === '#work' ? 'active' : ''} title='Work'><BiBriefcaseAlt2/></a>
      <a href='#experience' className={activeNav === '#experience' ? 'active' : ''} title='Skills'><AiOutlineProject/></a>
      <a href='#services' className={activeNav === '#services' ? 'active' : ''} title='Services'><BiNetworkChart/></a>
      <a href='#testimonials' className={activeNav === '#testimonials' ? 'active' : ''} title='Testimonials'><BiComment/></a>
      <a href='#contact' className={activeNav === '#contact' ? 'active' : ''} title='Contact'><AiOutlinePhone/></a>
    </nav>
  )
}

export default Nav